module.exports = __webpack_public_path__ + "static/PLAN3T-79ed51328ce1c9674ca13d17a242b14f.jpg";